module.exports = __webpack_public_path__ + "static/media/weight_icon.bc9ae036.png";